"use client";
import { CmdkPage } from "./Cmdk";
import { useCmdkPages__Home } from "./useCmdkPages__Home";

export function useCmdkPages(): CmdkPage[] {
  const homePage = useCmdkPages__Home();

  return [homePage];
}
